module.exports = __webpack_public_path__ + "static/media/ginlogo.868698b5.png";